<template>
  <v-row v-if="agent && !idNotGiven" justify="center">
    <v-card
      max-width="900"
      style="width: 100%;"
      :class="{ 'file-sign-list-width': $vuetify.breakpoint.smAndUp }"
      class="mt-8 px-2"
    >
      <v-card-text :class="{ 'px-6 pt-5': $vuetify.breakpoint.mdAndUp }">
        <div>{{ propertyName }} | <span class="primary--text">{{ date }}</span></div>
        <p class="text-h5 text--primary mb-0">
          Sähköinen sopimusmenettely
        </p>
      </v-card-text>
      <v-card-text class="pb-0">
        <v-text-field
          v-model="description"
          class="my-0"
          type="text"
          outlined
          placeholder="Sopimusmenettelyn nimi"
          label="Sähköisen sopimisen kuvaus"
          hint="Esim. jatkosopimus tai vuokrasopimus"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          depressed
          color="primary"
          :disabled="description.length < 1"
          @click="createNewProcess()"
        >
          Luo
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-row>
  <v-alert
    v-else
    type="warning"
    class="mx-4 mt-4"
    text
  >
    Virheellinen polku
  </v-alert>
</template>
<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import { apiGet, apiPost } from '../api';

export default {
  name: 'NewFileSigningProcess',

  data: () => ({
    propertyName: '',
    description: '',
    date: moment(new Date()).format('DD.MM.YYYY'),
  }),

  computed: {
    ...mapGetters({
      userDetails: 'userDetails',
    }),
    ...mapState({
      agent: state => state.agent,
    }),
    idNotGiven() {
      return !this.$route.params.id;
    },
  },

  async mounted() {
    const response = await apiGet(`properties/basicdetails/${this.$route.params.id}`);
    if (response.result && response.result.kohdenimi) {
      this.propertyName = response.result.kohdenimi;
    }
  },
  methods: {
    async createNewProcess() {
      const params = {
        name: this.description,
        propertyId: this.$route.params.id,
      };
      const response = await apiPost('customer/newfileprocess', params);
      if (response.success === 'true') {
        const logParams = {
          name: this.userDetails.nimi,
          description: 'loi sopimusmenettelyn',
        };
        console.warn(logParams);
        await apiPost('dropbox/log', logParams);
        this.$router.push(`/signfiles/${response.result}`);
      }
    },
  },
};
</script>
<style lang="scss">
  .file-sign-list-width {
    width: 100%;
    max-width: 600px;
  }
</style>
